import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { registerAgent, loginAgent, forgotPassword, clearForgotPasswordMessages } from "../../../redux/actions/sessionActions";

const LoginForm = ({ formMode, setFormMode }) => {
  const { handleSubmit, control, errors, watch, reset } = useForm();
  const { errors: sessionErrors, forgotPasswordMessage } = useSelector(state => state.sessionHandler);
  const dispatch = useDispatch();

  const isLogin = formMode === "login";
  const isRegister = formMode === "register";
  const isRegisterSuccess = formMode === "registerSuccess";
  const isForgot = formMode === "forgot";

  const onSubmit = (data) => {
    if (isRegister) {
      dispatch(registerAgent(data, () => {
        setFormMode("registerSuccess");
      }));
    } else if (isLogin) {
      const formData = new FormData();
      formData.append("username", data.email);
      formData.append("password", data.password);
      dispatch(loginAgent(formData));
    } else if (isForgot) {
       dispatch(forgotPassword({ email: data.email }, () => {
         reset({ email: "" }); 
    }));
    }
  };

  return (
    <form className="default-form" onSubmit={handleSubmit(onSubmit)}>
      <div className="row">

        <div className="col-sm-12">
          {(isLogin && sessionErrors.login) && (
                <div className="alert alert-danger">{sessionErrors.login}</div>
            )}
            {(isRegister && sessionErrors.register) && (
                <div className="alert alert-danger">{sessionErrors.register}</div>
            )}
        </div>

        {isForgot && (
          <div className="col-sm-12">
            {forgotPasswordMessage && (
              <div className="alert alert-success">{forgotPasswordMessage}</div>
            )}
            {sessionErrors.forgot && (
              <div className="alert alert-danger">{sessionErrors.forgot}</div>
            )}
          </div>
        )}

        {isRegisterSuccess && (
          <div className="col-md-12 text-center">
            <p>
              Registration successful! You can now{" "}
              <a href="#" onClick={(e) => {
                e.preventDefault();
                setFormMode("login");
              }} style={{ color: "#5928d1", textDecoration: "underline" }}>
                login here.
              </a>
            </p>
          </div>
        )}

        {!isRegisterSuccess && (
          <>
            {isRegister && (
              <>
                <div className="col-md-12">
                  <div className="form-group">
                    <label>First Name</label>
                    <Controller
                      as={<input className="form-control" />}
                      name="first_name"
                      control={control}
                      defaultValue=""
                      rules={{ required: true }}
                    />
                    {errors.firstName && (
                      <small className="form-text text-danger">First Name is required!</small>
                    )}
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="form-group">
                    <label>Last Name</label>
                    <Controller
                      as={<input className="form-control" />}
                      name="last_name"
                      control={control}
                      defaultValue=""
                      rules={{ required: true }}
                    />
                    {errors.lastName && (
                      <small className="form-text text-danger">Last Name is required!</small>
                    )}
                  </div>
                </div>
              </>
            )}

            <div className="col-md-12">
              <div className="form-group">
                <label>Email</label>
                <Controller
                  as={<input className="form-control" />}
                  name="email"
                  control={control}
                  defaultValue=""
                  rules={{
                    required: true,
                    pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/
                  }}
                />
                {errors.email && (
                  <small className="form-text text-danger">
                    {errors.email.type === "required" ? "Email is required!" : "Invalid email"}
                  </small>
                )}
              </div>
            </div>

            {(isLogin || isRegister) && (
              <div className="col-md-12">
                <div className="form-group">
                  <label>Password</label>
                  <Controller
                    as={<input type="password" className="form-control" />}
                    name="password"
                    control={control}
                    defaultValue=""
                    rules={{ required: true }}
                  />
                  {errors.password && (
                    <small className="form-text text-danger">Password is required!</small>
                  )}
                </div>
              </div>
            )}

            {isRegister && (
              <>
                <div className="col-md-12">
                  <div className="form-group">
                    <label>Confirm Password</label>
                    <Controller
                      as={<input type="password" className="form-control" />}
                      name="confirm_password"
                      control={control}
                      defaultValue=""
                      rules={{
                        required: "Confirm Password is required!",
                        validate: value =>
                          value === watch("password") || "Passwords do not match"
                      }}
                    />
                    {errors.confirmPassword && (
                      <small className="form-text text-danger">{errors.confirmPassword.message}</small>
                    )}
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="form-group">
                    <label>Organization</label>
                    <Controller
                      as={<input className="form-control" />}
                      name="organization"
                      control={control}
                      defaultValue=""
                      rules={{ required: true }}
                    />
                    {errors.organization && (
                      <small className="form-text text-danger">Organization is required!</small>
                    )}
                  </div>
                </div>
              </>
            )}

            <div className="col-sm-12 text-center">
              <button type="submit" className="btn btn-small btn-gradient btn-rounded mt-4">
                {isRegister ? "Register" : isForgot ? "Send Reset Link" : "Log In"}
              </button>
            </div>
          </>
        )}

        {!isRegisterSuccess && (
          <div className="col-md-12 col-sm-12 text-center mt-3">
            {isLogin && (
              <p>
                Don’t have an account?{" "}
                <a href="#" onClick={(e) => { e.preventDefault(); setFormMode("register"); }} style={{ color: "#5928d1", textDecoration: "underline" }}>
                  Register here
                </a><br/>
                <a href="#" onClick={(e) => { e.preventDefault();  dispatch(clearForgotPasswordMessages()); setFormMode("forgot"); }} style={{ color: "#5928d1", textDecoration: "underline" }}
                >
                Forgot Password
                </a>
              </p>
            )}
            {isRegister && (
              <p>
                Already have an account?{" "}
                <a href="#" onClick={(e) => { e.preventDefault(); setFormMode("login"); }} style={{ color: "#5928d1", textDecoration: "underline" }}>
                  Login here
                </a>
              </p>
            )}
            {isForgot && (
              <p>
                Go back to{" "}
                <a href="#" onClick={(e) => { e.preventDefault(); setFormMode("login"); }} style={{ color: "#5928d1", textDecoration: "underline" }}>
                  Login
                </a>
              </p>
            )}
          </div>
        )}

      </div>
    </form>
  );
};

export default LoginForm;